import { withInstall } from '@lit-element/utils'

import Masker from './src/masker.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtMasker: SFCWithInstall<typeof Masker> = withInstall(Masker)
export default LtMasker

export * from './src/masker'
